import { useEffect, useMemo } from 'react';

import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import InvitationForm from '@webclient/components/invitation-form';
import Users from '@webclient/components/settings/components/tabs/knowledge-base/components/users';
import WorkspaceSetupProvider from '@webclient/components/workspace/setup/providers/WorkspaceSetupProvider';

import useWorkspace from '@webclient/hooks/useWorkspace';

import { Text } from '@knowz/knowz-ui';
import useWorkspaceSelection from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/hooks/useWorkspaceSelection';

export default function KnowledgeBaseManagement() {
  const theme = useTheme();

  const { handleSetWorkspace, workspace, setupMode } = useWorkspace();
  const {
    selectedWorkspaceId,
    selectedWorkspaceData,
    handleSetSelectedWorkspaceId,
  } = useWorkspaceSelection();

  const initialConfig = useMemo(() => {
    return { workspace, setupMode };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!selectedWorkspaceId) return;
    selectedWorkspaceData
      ? handleSetWorkspace(selectedWorkspaceData, 'on')
      : handleSetWorkspace(null, 'off');
  }, [
    handleSetSelectedWorkspaceId,
    handleSetWorkspace,
    selectedWorkspaceData,
    selectedWorkspaceId,
  ]);

  useEffect(() => {
    return () => {
      // Reset setReadingOwnerHeader & setCreationOwnerHeader headers
      handleSetWorkspace(
        initialConfig.workspace,
        initialConfig.setupMode || 'off',
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (selectedWorkspaceData?.role === 'owner') {
    return (
      <Stack gap={3}>
        <WorkspaceSetupProvider>
          <InvitationForm />
        </WorkspaceSetupProvider>

        <Divider />

        <Stack>
          <Text
            variant="textSm"
            weight="semibold"
            color={theme.palette['Colors/Text/text-secondary (700)']}
          >
            Team members
          </Text>

          <Text
            variant="textSm"
            color={theme.palette['Colors/Text/text-tertiary (600)']}
          >
            Manage your existing team and change roles/permissions.
          </Text>
        </Stack>

        <Users />
      </Stack>
    );
  }

  return null;
}
